import { Button } from "@material-ui/core"
import { ClassNameMap } from "@material-ui/core/styles/withStyles"
import { useState } from "react";
import KitPackagesDialog from "./KitPackagesDialog";

interface Properties {
  classes: ClassNameMap<'button'>;
  customerId: number;
  priceListId: number;
  kitId: number;
  reportAlert: (message: string) => void;
}

const KitPackaging = (properties: Properties) => {
  const [kitPackagingDialogOpen, setKitPackagingDialogOpen] = useState<boolean>(false);

  const handleKitPackagingDialogOpenClicked = () => {
    setKitPackagingDialogOpen(true);
  };

  const handleKitPackagingDialogClosed = () => {
    setKitPackagingDialogOpen(false);
  };

  return <>
    <KitPackagesDialog
      customerId={ properties.customerId }
      priceListId={ properties.priceListId }
      kitId={ properties.kitId }
      open={ kitPackagingDialogOpen }
      onDialogClosed={ handleKitPackagingDialogClosed }
      reportAlert={ properties.reportAlert }
    />
    <Button
      color='primary'
      className={properties.classes.button}
      onClick={() => handleKitPackagingDialogOpenClicked()}
      variant='contained'
    >
      Otwórz specyfikację pakowania
    </Button>
  </>
};

export default KitPackaging;